import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

// images
import collectTradeIcon from "../assets/icons/collect-trade-icon.png";
import eventAccessIcon from "../assets/icons/event-access-icon.png";
import archiveViewingIcon from "../assets/icons/archive-viewing-icon.png";
import futureAirdropsIcon from "../assets/icons/future-airdrops-icon.png";

export const HeroFeatures = () => {
   return (
      <Grid item xs={12} style={{ marginTop: 30 }}>
         <Grid container spacing={3} style={{ textAlign: 'center' }} justifyContent='center'>
            <Grid item xs={6} md={3}>
            <div><img src={collectTradeIcon} alt="They Are Rare!" style={{ width: '84px' }} /></div>
            <Typography variant="caption">
               They Are Rare!
            </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
            <div><img src={eventAccessIcon} alt="Visual Identity" style={{ width: '84px' }} /></div>
            <Typography variant="caption">
               Visual Identity
            </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
            <div><img src={archiveViewingIcon} alt="Special Access" style={{ width: '84px' }} /></div>
            <Typography variant="caption">
               Special Access
            </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
            <div><img src={futureAirdropsIcon} alt="Value Backed" style={{ width: '84px' }} /></div>
            <Typography variant="caption">
               Sell & Trade
            </Typography>
            </Grid>
         </Grid>
      </Grid>
   )
}